// extracted by mini-css-extract-plugin
export default {"subtitle":"DocListComissionStatuses_subtitle__NW45X","title":"DocListComissionStatuses_title__NXWEG"};